// extracted by mini-css-extract-plugin
export var productImage = "_od-0";